/**
 * Strips internal ticket/rule refs (e.g. CR-14, SUB-09) from labels meant for end users.
 * Seed/admin names may still contain them; never show them in the portal UI. Generic
 * `[A-Z]{2,5}-\d+` pattern - covers any future internal reference of the same shape.
 */
export function sanitizeInternalTicketRefs(label: string): string {
  return label
    .replace(/ - démo [A-Z]{2,5}-\d+/gi, '')
    .replace(/\([A-Z]{2,5}-\d+\)/gi, '')
    .replace(/ [A-Z]{2,5}-\d+/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/\(\s*\)/g, '')
    .trim()
}
